import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/app/[slug]/error.tsx");
